import { render, staticRenderFns } from "./EditCategories.vue?vue&type=template&id=dec84764&"
import script from "./EditCategories.vue?vue&type=script&lang=js&"
export * from "./EditCategories.vue?vue&type=script&lang=js&"
import style0 from "./EditCategories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports